var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconContracted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10.568,
  height: 10.377,
  viewBox: "0 0 10.568 10.377"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.91.547l-4.98,8L7.122,4.923",
  transform: "translate(-5.719 0.83)",
  fill: "none",
  stroke: "#e6e6e6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));
export default SvgIconContracted;